import { gql } from '@apollo/client';

export const getIdentityValidation = gql`
  query GetIdentityValidation {
    getIdentityValidation {
      value {
        id
        documentCode
        documentType
        documentIssueDate
        identityDocument {
          status
        }
        identityDocument2 {
          status
        }
        picture {
          status
        }
        stage
      }
    }
  }
`;
